// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Hr57","inner":"Footer_inner__1f00s"};